import { ChartLegend } from '../../../core/components/legend/categorical/ChartLegend.js';
import { LegendItem } from '../../../core/components/legend/categorical/types/legend.js';
import { LegendSizeContext } from '../../../core/components/legend/shared/context/LegendSizeContext.js';
import { useMultiMeterBarSegmentsState } from '../hooks/store/selectors.js';
import { useMultiMeterBarStore } from '../hooks/useMultiMeterBarStore.js';

export interface MultiMeterBarChartLegendProps {
  width: number;
}

export const MultiMeterBarChartLegend = (
  props: MultiMeterBarChartLegendProps,
) => {
  const { width } = props;
  const { setVisibleSegments, setHighlightedSegments } =
    useMultiMeterBarStore();

  const segments = useMultiMeterBarSegmentsState();

  const legendItems = segments.map((segment) => ({
    id: segment.id,
    color: {
      Default: segment.color,
    },
    name: segment.name,
  }));

  const onClickHandler = (visibleSegments: LegendItem[]) => {
    setVisibleSegments(visibleSegments);
  };

  const onHoverHandler = (highlightedSegments?: LegendItem[]) =>
    setHighlightedSegments(highlightedSegments);

  return (
    // the height value is set through the CSS style
    <LegendSizeContext.Provider value={{ width, height: 0 }}>
      <ChartLegend
        items={legendItems}
        onClick={onClickHandler}
        onHover={onHoverHandler}
        style={{ height: '100% ' }}
      />
    </LegendSizeContext.Provider>
  );
};

MultiMeterBarChartLegend['displayName'] = 'MultiMeterBarChartLegend';
